/**
 * National Insurance number format. The e-Bulk specification (3.7.3, section-4 row 6) allows any of
 * ABCEGHJKLMNOPRSTWXYZ in the first two positions and A-D or a space last; HMRC's own rules (NIM39110) are tighter
 * and are what we apply, because a number the DBS would accept but HMRC never issued is still wrong (DBS-307).
 */
export const isValidNationalInsuranceNumber = (niNumber: string): 'yes' | 'no-invalid-format' | 'no-invalid-start' => {
  // https://www.gov.uk/hmrc-internal-manuals/national-insurance-manual/nim39110
  if (!/^[A-CEGHJ-PR-TW-Z][A-CEGHJ-NPR-TW-Z]\d{6}[A-D]$/.test(niNumber)) {
    return 'no-invalid-format'
  } else if (/^(BG|GB|KN|NK|NT|TN|ZZ).*$/.test(niNumber)) {
    return 'no-invalid-start'
  }
  return 'yes'
}
